import {
  ImageService,
  ApiService,
  ListingModalService,
  ShepherdService,
} from "@DavisDigital/davisdigitalfrontend.module";

import * as IDavis from "@DavisDigital/interfaces";
import { returnFocus, getNextFocusable } from "../services/modal-focus-return";

declare var angular: any;

export class ImageController {
  public addToExistingImageSet: boolean = false;
  public displayReadMore: boolean = false;
  public selectedCompareImages = {};
  public isDev: boolean;
  public tabClasses: IDavis.ImageTabClasses;
  public image: IDavis.IImage;
  public imageSet: IDavis.IImageSet;
  public images: IDavis.ImageCollectionList;
  public imageSets: IDavis.ImageSetCollectionList;
  public imageSetImages: IDavis.ImageCollectionList;
  public imageSetBackgroundColor: string = "";
  public selectedtab: IDavis.ImageTab = "imagesearch";
  public imageDetailDisplayFullDescription: boolean = false;
  public imageID: string = "";
  public imageSetID: string = "";
  public imageSetName: string = "";
  public imageSetKeywords: string = "";
  public imageSetOptions: any[];
  public imageSetTimeoutPromise;
  public selectedBookImageOption: any;
  public selectedChapterImageOption: any;
  public selectedBookLessonImageOption: any;
  public imageSetToDelete: any;
  public backlinktext: string = "Image Search";

  public permissions: any;

  public processing: boolean = true;

  public currentPage: number = 1;
  public referrerPage: number = 1;
  public referrerImagePage: number = 1;
  public totalPages: number = 1;
  public keywords: string = "";
  public sortOrder: number | string = 1;
  public editingSortOrder: boolean = false;

  public k5appropriate: boolean = true;
  public imageSelection: string[] = [];
  public modalSaveAction: string;

  public referrerImageID: string;
  public referrerImageSetID: string;

  public reorderedImageSetImages = [];

  public selectedImageSet;
  public selectedImageSets: any[];

  public superUser: any;

  public imageSetToBeDeleted: IDavis.IImageSet;

  public sharedWithTeacher: boolean = false;
  public sharedWithStudent: boolean = false;

  public showAddToCollection: boolean = false;

  public shepherdInit: boolean = true;

  public selectedItem: any;

  public arrayImagesIDs = [];
  public selectedLessonId: any;

  public imageOptionsLoading: boolean = false;
  public chapterImageOptionsLoading = false;
  public bookLessonImageOptionsLoading = false;
  private previouslyFocusedElement: HTMLElement | null = null;
	private focusableSelector = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
	// Element that had focus before the full-screen image dialog opened. Focus
	// is returned here when the dialog closes (WCAG 2.4.3 Focus Order).
	private fullscreenTriggerElement: HTMLElement | null = null;

  public collectionBackgroundColors: any = {
    options: [
      { value: "ffffff", label: "White" },
      { value: "000000", label: "Black" },
      { value: "ededed", label: "Grey" },
      { value: "7b2e5c", label: "Purple" },
      { value: "27427e", label: "Blue" },
      { value: "fbb116", label: "Yellow" },
      { value: "1a998b", label: "Teal" },
      { value: "89bb3f", label: "Green" },
      { value: "f1643c", label: "Orange" },
      { value: "d01f3a", label: "Red" },
      { value: "da0862", label: "Pink" },
    ],
  };

  public pageSize: any = {};

  public imagePageSize: any = {
    options: [
      { value: "20", label: "Default" },
      { value: "24", label: "24" },
    ],
  };

  public myCollectionsPageSize: any = {
    options: [
      { value: "20", label: "Default" },
      { value: "50", label: "50" },
      { value: "100", label: "100" },
    ],
  };

  public sharedCollectionsPageSize: any = {
    options: [
      { value: "15", label: "15" },
      { value: "25", label: "25" },
      { value: "50", label: "50" },
      { value: "100", label: "100" },
    ],
  };

  //original property to use with APIs
  public sortBy: any = {};

  public imageSortBy: any = {
    options: [
      { value: "artistName", label: "Artist Name" },
      { value: "imageName", label: "Image Name" },
    ],
  };

  //same will be used for both my collections and district collections
  public myCollectionsSortBy: any = {
    options: [
      { value: "createdDateTime", label: "Most Recent" },
      { value: "title", label: "A-Z" },
    ],
  };

  public sharedCollectionsSortBy: any = {
    options: [
      { value: "modifiedDateTime", label: "Recently Shared" },
      { value: "title", label: "Collection Title" },
      { value: "account.firstName", label: "Creator Name" },
    ],
  };

  public davisCollectionsSortBy: any = {
    options: [
      //{value : 'createdDateTime', label: 'Most Recent'}, // No data for this field for legacy sets
      { value: "title", label: "A-Z" },
    ],
  };

  public bookCollectionsSortBy: any = {
    options: [
      //{value : 'createdDateTime', label: 'Most Recent'}, // No data for this field for legacy sets
      { value: "title", label: "A-Z" },
    ],
  };
  //Additional Filter Options
  public optionsConfig = {
    artisticForm: [],
    artisticStyle: [],
    "nation.nationID": [],
    originalWorkCity: [],
    originalWorkMaterial: [],
    "museum.museumID": [],
    "periods.periodID": [],
    originalWorkSubject: [],
    bookImageOptions: [],
    chapterImageOptions: [],
    bookLessonImageOptions: [],
  };

  public filterConfig = {};

  public filtersExpanded = false;
  public filterOptionsLoaded = false;
  public filtersLoading = false;

  //Additional Keywords Configuration
  public keywordConfig = {};

  // @ngInject
  constructor(
    private $scope,
    private $element,
    private $q: ng.IQService,
    private $rootScope: ng.IRootScopeService,
    private $timeout: ng.ITimeoutService,
    private $location: ng.ILocationService,
    private $window: ng.IWindowService,
    private apiService: ApiService,
    private imageService: ImageService,
    private listingModalService: ListingModalService,
    private ModalService,
    private observerService,
    private shepherdService: ShepherdService,
    private davisAlertService
  ) { }

  // ------------------------------	Setup	------------------------------

  private $onInit = (): void => {
    // Store the element that had focus before the modal opened
		this.previouslyFocusedElement = document.activeElement as HTMLElement;
    this.isDev = this.$location.host() === "davisdigital";
    // because we're using $location in some areas, this will help when a user clicks their browser's `back` button
    this.$rootScope.$on("$locationChangeStart", this.onLocationChangeStart);

    this.collectionBackgroundColors["selected"] =
      this.collectionBackgroundColors.options[0];

    // start spinner, parse the query string, then set the selected tab
    this.parseQueryString().setSelectedTab();

    this.observerService.attach(
      this.handleImageSortOrderUpdate,
      "imageSortOrderUpdated"
    );

    //set keyword and filter config
    this.resetKeywordConfig().resetFilterConfig();

    if (
      typeof this.$location.search().keywords != undefined &&
      typeof this.$location.search().keywords?.length && this.$location.search().keywords !== undefined
    ) {
      let urlKeyword: string = this.$location.search().keywords;
      this.go(false, urlKeyword);
    }
    if (
      typeof this.$location.search().imageFilter != undefined &&
      typeof this.$location.search().imageFilterValue != undefined
    ) {
      //load default filter options first if passed in URL
      this.loadFilterOptions().then(() => {
        this.applyDefaultFilter(
          this.$location.search().imageFilter,
          this.$location.search().imageFilterValue
        );
        this.go();
      });
    } else {
      this.go();
    }
  };

  public initTooltip = () => {
    $('[data-toggle="tooltip"]').tooltip();

    $("#tooltipCompare").hover(() => {
      if ($("#compareImages").hasClass("disabled")) {
        $("#tooltipCompare").tooltip("enable");
      } else {
        $("#tooltipCompare").tooltip("disable");
      }
    });
  };

  private onLocationChangeStart = (
    ngEvent: any,
    newUrl: string,
    oldUrl: string,
    newState: string,
    oldState: string
  ): void => {
    if (oldUrl.search("tab") !== -1 && newUrl !== oldUrl) {
      this.go();
    }
  };

  public go = (resetPage = false, urlKeyword: string = ""): this => {
    // clear images + imageSets prior to processing
    this.images = {};
    this.imageSets = {};
    this.imageSetImages = {};
    if (this.imageID.length) {
      this.setImage(this.imageID);
    }

    if (this.imageSetID.length) {
      this.setImageSet(this.imageSetID);
    }
    if (this.keywords.length) {
      this.setKeywords(this.keywords);
    }
    if (resetPage) {
      this.currentPage = 1;
    }

    // actions are based on the selected tab ...
    if (!this.imageID.length && !this.imageSetID.length) {
      let that = this;

      switch (this.selectedtab) {
        case "mycollections":
        case "sharedcollections":
        case "daviscollections":
          that.setImageSets();
          break;
        case "bookcollections":
          that.setImageSets();
          break;
        case "imagesearch":
          if (this.keywords.length) {
            that.setImages(this.keywords);
          } else if (urlKeyword.length) {
            that.setImages(urlKeyword);
          } else {
            that.setImages();
          }

          break;
        default:
          that.handleError({
            message: "go() Error!!",
            detail: "Unknown tab: " + that.selectedtab,
          });
      }
    }

    return this;
  };

  public parseQueryString = (): this => {
    const queryString = this.$location.search();
    this.setImageId(queryString.imageid || "")
      .setImageSetID(queryString.imagesetid || "")
      .setKeywords(queryString.keywords || "")
      .setReferrerImageID(queryString.referrerImageID || "")
      .setReferrerImageSetID(queryString.referrerImageSetID || "");

    // clear pagination variable if viewing a `detail` page
    if (this.imageID.length || this.imageSetID.length) {
      this.setLocation("currentPage", "");
      this.setLocation("keywords", "");
    }
    return this;
  };

  // @END :: Setup

  // ------------------------------	Handlers	------------------------------

  public handleAddImageToImageSet = (
    image: IDavis.IImage,
    imageSet: IDavis.IImageSet
  ) => {
    this.imageService
      .addImageToImageSet(image.imageID, imageSet.imageSetID)
      .then((response: any) => {
        if (response.success) {
          this.image.imageSets.splice(0, 0, imageSet);
          this.imageSetOptions = this.arrayDelete(
            this.imageSetOptions,
            imageSet
          );
          this.imageSetKeywords = "";
          this.selectedImageSet = null;
        }
      });

    return this;
  };

  public handleAddImageSelectionToImageSet = (
    imageSets: any[] = this.selectedImageSets
  ) => {
    this.imageService
      .saveImageSets(imageSets, this.imageSelection)
      .then((response: any) => {
        if (response) {
          //go to image set?
          this.setTotalPages(1)
            .setCurrentPage(1)
            .setImageId("")
            .setImageSelection([])
            .setImageSetID(response.imageSetID)
            .setSelectedTab("mycollections", "My Collections");

          this.davisAlertService.success(
            "Your image has been added to the collection(s) selected."
          );
        }
      })
      .finally(() => {
        this.addToExistingImageSet = false;
        this.showAddToCollection = false;
        this.selectedImageSet = null;
        this.selectedImageSets = null;
        this.imageSetOptions = null;
        this.imageSetKeywords = "";
        this.handleImageSetKeywords();
      });
  };

  public handleBack = (preserveImageSet: boolean = false, preserveImage: boolean = false): this => {

    if (preserveImageSet && this.imageSetID) this.setReferrerImageSetID(this.imageSetID);
    if (preserveImage && this.imageID) this.setReferrerImageID(this.imageID);

    this.setImageSetID('');
    this.setImageId('')

    if (!preserveImageSet && this.referrerImageSetID != null) {
      return this.setImageSetID(this.referrerImageSetID)
        .setReferrerImageSetID('')
        .setSelectedTab(this.selectedtab);
    }


    if (!preserveImage && this.referrerImageID != null) {
      return this.setImageId(this.referrerImageID)
        .setReferrerImageID('')
        .setSelectedTab('imagesearch');
    }

    if (!preserveImageSet && this.referrerImageSetID == null) {
      if (this.selectedtab == 'imagesearch') {
        return this.setReferrerImageSetID('')
          .setCurrentPage(this.referrerImagePage, true)
          .setSelectedTab(this.selectedtab);
      }
      return this.setReferrerImageSetID('')
        .setCurrentPage(this.referrerPage, true)
        .setSelectedTab(this.selectedtab);
    }
    return this.setSelectedTab();
  }

  public handleCollectionTags = (image: any) => {
    if (image.imageSets != null) return;

    this.imageService
      .getImageSetsForImage(image)
      .then((response: any) => {
        image.imageSets = response;
      })
      .finally(() => {
        image.imageSetsLoaded = true;
      });

    return this;
  };

  public handleCompareAndContrast = (type = "images", $event?: any) => {
    if (this.imageSelection.length != 2) return;

    // Capture the Compare and Contrast button now: angular-modal-service blurs the
    // active element when the dialog opens, so it can't be read later (WCAG 2.4.3).
    const trigger: HTMLElement | null =
      ($event && ($event.currentTarget as HTMLElement)) ||
      (document.activeElement !== document.body
        ? (document.activeElement as HTMLElement)
        : document.getElementById("compareImages"));

    this.ModalService.showModal({
      component: "compareImagesModal",
      bodyClass: "angular-modal-service-active",
      bindings: {
        firstImage: this.getFirstCompareImage(),
        secondImage: this.getSecondCompareImage(),
      },
      preClose: (modal) => {
        modal.element.modal("hide");
      },
    }).then((modal) => {
      //it's a bootstrap element, use 'modal' to show it
      modal.element.modal("show");

      const restore = () =>
        this.$timeout(() => returnFocus(trigger, this.ModalService), 0, false);

      // Close button and Esc go through ModalService.closeModals(); `closed` resolves
      // once the modal markup is removed, so focus can't land on a hidden element.
      if (modal.closed && typeof modal.closed.then === "function") {
        modal.closed.then(restore);
      }
      // Bootstrap can also dismiss the dialog itself (backdrop click, its own Esc
      // handler) without going through ModalService, so restore on its hidden event too.
      modal.element.one("hidden.bs.modal", restore);
    });
  };

  private getFirstCompareImage(): any {
    if (this.imageSelection.length > 0) {
      return this.selectedCompareImages[this.imageSelection[0]];
    }
    return null;
  }

  private getSecondCompareImage(): any {
    if (this.imageSelection.length > 1) {
      return this.selectedCompareImages[this.imageSelection[1]];
    }
    return null;
  }

  public handleDownloadImage = (image: IDavis.IImage) => {
    var anchor = document.createElement("a");
    anchor.href =
      "?slatAction=davisdigital:api.downloadImage&imageID=" + image.imageID;
    anchor.target = "_blank";
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
  };

  public handleImageDescription = (image: any): any => {
    var sentences = image.imageDescription.split("</p>");

    this.displayReadMore = sentences.length > 2;
    image.initialDescription = image.imageDescription;

    if (this.displayReadMore) {
      image.initialDescription = sentences[0];
    }

    return image;
  };

  public handleImageSetKeywords = (
    imageSetKeywords = this.imageSetKeywords,
    debounce = 1000
  ) => {
    this.imageSetKeywords = imageSetKeywords;

    if (this.imageSetKeywords.length == 0) {
      return;
    }

    if (this.imageSetTimeoutPromise) {
      this.$timeout.cancel(this.imageSetTimeoutPromise);
    }

    var imageIDArray = [];

    if (this.imageID) {
      imageIDArray.push(this.imageID);
    }

    this.imageSetTimeoutPromise = this.$timeout(() => {
      this.imageService
        //get all image sets that match keywords, most arguments adhere to defaults
        .getImageSets(
          1,
          20,
          this.imageSetKeywords,
          true,
          imageIDArray,
          "title",
          true
        )
        .then((response) => {
          this.imageSetOptions = response.pages;
        });
    }, debounce);

    return this;
  };

  public triggerShepherdImageCollection = () => {
    if (this.shepherdInit == true && this.selectedtab == "mycollections") {
      this.shepherdService.initShepherdImageCollection(this.selectedtab);
      this.shepherdInit = false;
    }
  };

  public handleImageSortOrderUpdate = (args) => {
    this.reorderedImageSetImages = args;
  };

  public handleKeywords = (keywords: string): this => {

    return this.setKeywords(keywords).go();

  };

  public handleFilterSearch = (): this => {
    return this.toggleFiltersExpanded().go();
  };

  public handleRemoveImageFromImageSet = (
    image: IDavis.IImage,
    imageSet: IDavis.IImageSet
  ) => {
    const that = this;
    this.ModalService.showModal({
      component: "confirmDeleteModal",
      bodyClass: "angular-modal-service-active",
      bindings: {
        title: "The image will be removed from the selected collection.",
        deleteAction: "remove",
        type: "collection",
        closeCallback: (confirmDelete = false) => {
          return confirmDelete
            ? that.imageService
              .removeImageFromImageSet(image.imageID, imageSet.imageSetID)
              .then((response: any) => {
                if (response.success) {
                  that.image.imageSets = that.arrayDelete(
                    that.image.imageSets,
                    imageSet
                  );
                  that.imageSetOptions.push(imageSet);
                }
              })
            : false;
        },
      },
      preClose: (modal) => {
        modal.element.modal("hide");
      },
    }).then((modal) => {
      //it's a bootstrap element, use 'modal' to show it
      modal.element.modal("show");
      modal.close.then((result) => { });
    });

    return this;
  };

  public handleRemoveImageSelectionsFromImageSet = (
    imageSet = this.imageSet,
    images = this.imageSelection
  ) => {
    const that = this;
    this.ModalService.showModal({
      component: "confirmDeleteModal",
      bodyClass: "angular-modal-service-active",
      bindings: {
        title: "The image will be removed from the selected collection.",
        deleteAction: "remove",
        type: "collection",
        closeCallback: (confirmDelete = false) => {
          this.setProcessing(true);
          return confirmDelete
            ? that.imageService
              .removeImagesFromImageSet(images, imageSet.imageSetID)
              .then((response: any) => {
                if (response.success) {
                  that.imageSetImages = response.imageSetImages;
                  that.imageSelection = [];
                }
              })
              .finally(() => {
                this.setProcessing(false);
              })
            : this.setProcessing(false);
        },
      },
      preClose: (modal) => {
        modal.element.modal("hide");
      },
    }).then((modal) => {
      //it's a bootstrap element, use 'modal' to show it
      modal.element.modal("show");
      modal.close.then((result) => { });
    });

    return this;
  };

  public handleReorderImages = () => {
    this.editingSortOrder = !this.editingSortOrder;

    this.reorderAnnouncement = this.editingSortOrder
      ? "Reorder mode on. Use the Move earlier and Move later buttons, or the arrow keys, to change image order. Activate Save Image Order when finished."
      : this.reorderedImageSetImages.length > 0
        ? "Reorder mode off. Saving image order."
        : "Reorder mode off.";

    if (!this.editingSortOrder && this.reorderedImageSetImages.length > 0) {
      this.imageService.saveImageSortOrderForImageSet(
        this.imageSetID,
        this.reorderedImageSetImages
      );

      this.reorderedImageSetImages = [];
    }
  };

  // Message read by the aria-live region after a keyboard reorder
  public reorderAnnouncement: string = "";

  /**
   * Keyboard-accessible equivalent of drag-and-drop reordering (WCAG 2.1.1).
   * Moves the image at `fromIndex` to `toIndex`, records the new order for saving,
   * announces the change, and keeps focus on the moved image's controls.
   */
  public moveImage = (fromIndex: number, toIndex: number, focusAction: string = ""): void => {
    const pages: any[] = this.imageSetImages?.pages;
    if (!pages || !this.editingSortOrder) return;

    const lastIndex = pages.length - 1;
    toIndex = Math.max(0, Math.min(lastIndex, toIndex));
    if (fromIndex === toIndex || fromIndex < 0 || fromIndex > lastIndex) return;

    const [moved] = pages.splice(fromIndex, 1);
    pages.splice(toIndex, 0, moved);

    // Same payload the drag-and-drop flow produces; saved on "Save Image Order"
    this.reorderedImageSetImages = pages;

    // Clear first so repeated identical messages are still announced
    this.reorderAnnouncement = "";
    this.$timeout(() => {
      this.reorderAnnouncement =
        `${moved.image_imageName} moved to position ${toIndex + 1} of ${pages.length}.`;
    }, 100);

    // ng-repeat tracks by $index, so focus must follow the image to its new slot
    this.$timeout(() => {
      const container: HTMLElement = this.$element[0];
      const preferred = container.querySelector(
        `[data-reorder-index="${toIndex}"][data-reorder-action="${focusAction}"]:not([disabled])`
      ) as HTMLElement;
      const fallback = container.querySelector(
        `[data-reorder-index="${toIndex}"]:not([disabled])`
      ) as HTMLElement;
      (preferred || fallback)?.focus();
    }, 0);
  };

  /**
   * Arrow / Home / End key support on the reorder controls.
   */
  public handleReorderKeydown = ($event: KeyboardEvent, index: number): void => {
    const pages: any[] = this.imageSetImages?.pages || [];
    let target: number = null;
    let action = "";

    switch ($event.key) {
      case "ArrowLeft":
      case "ArrowUp":
        target = index - 1;
        action = "earlier";
        break;
      case "ArrowRight":
      case "ArrowDown":
        target = index + 1;
        action = "later";
        break;
      case "Home":
        target = 0;
        action = "earlier";
        break;
      case "End":
        target = pages.length - 1;
        action = "later";
        break;
      default:
        return;
    }

    $event.preventDefault();
    this.moveImage(index, target, action);
  };

  public handleSortOrder = (sortOrder: any): this => {
    return this.setSortOrder(sortOrder).go();
  };

  public handleK5AppropriateChange = (disabled): this => {
    if (disabled) return;
    return this.setK5Appropriate(this.k5appropriate).go();
  };

  public handlePageChange = (currentPage: number): this => {
    return this.setCurrentPage(currentPage); //.go();
  };

  public handleSelectImage = (
    imageID: string,
    backText: string = "Image Search"
  ): this => {
    if (this.referrerImageID != null) {
      this.setReferrerImageID(null);
      this.setBacklinkText(backText);
    }

    if (this.imageSetID) {
      this.setReferrerImageSetID(this.imageSetID);
      this.setImageSetID("");
    }
    this.setReferrerImagePage(this.currentPage);

    return this.setImageId(imageID).go();
  };

  public handleSelectImageSet = (imageSet, backText: string = "Image") => {
    if (this.referrerImageSetID != null) {
      this.setReferrerImageSetID(null);
      this.setBacklinkText(backText);
    }

    if (!this.selectedImageSets) {
      this.selectedImageSets = [];
    }

    imageSet.selected = !imageSet.selected;

    var removed = false;

    for (var i = 0; i < this.selectedImageSets.length; i++) {
      if (this.selectedImageSets[i].imageSetID === imageSet.imageSetID) {
        this.selectedImageSets.splice(i, 1);
        removed = true;
        break;
      }
    }

    if (!removed) {
      this.selectedImageSets.push(imageSet);
    }
  };

  public handleSelectedImageSet = (
    imageSetID: string,
    selectedTab?: IDavis.ImageTab,
    referrerImageID = this.imageID
  ): this => {
    if (referrerImageID != null && referrerImageID) {
      this.setReferrerImageID(referrerImageID);
    }

    var backlinkText;

    if (!selectedTab) {
      selectedTab = this.selectedtab;
    }

    switch (selectedTab) {
      case "daviscollections":
        backlinkText = "Davis Collections";
        break;
      case "bookcollections":
        backlinkText = "Book Collections";
        break;
      case "sharedcollections":
        backlinkText = "Shared Collections";
        break;

      default:
        // backlinkText = referrerImageID ? "Image" : "My Collections";
        backlinkText = "My Collections";
    }

    return this.setTotalPages(1)
      .setReferrerPage(this.currentPage)
      .setCurrentPage(1)
      .setImageId("")
      .setImageSetID(imageSetID)
      .setImageSelection([])
      .setSelectedTab(selectedTab, backlinkText);
    //.go();
  };

  // @END go()

  public handleNewImageSet = (
    title = this.imageSetName,
    arrayImageIDs = this.imageSelection
  ): this => {
    this.setProcessing(true);
    let that = this;

    let imageSet: IDavis.IImageSet = {
      title: title,
      backgroundColor: this.collectionBackgroundColors["selected"].value,
      arrayImageIDs: arrayImageIDs,
    };

    this.imageService
      .saveImageSet(imageSet)
      .then((value: IDavis.IImageSet): void => {
        that
          .setTotalPages(1)
          .setCurrentPage(1)
          .setImageId(this.imageID)
          .setImageSelection([])
          .setImageSetID("")
          .setSelectedTab("mycollections", "My Collections");

        this.davisAlertService.success("Your new collection has been created.");
      })
      .catch((reason: any): void => {
        that.handleError(reason);
      })
      .finally((): void => {
        that.imageSetKeywords = "";
        that.imageSetName = "";
        that.backlinktext = "My Collections";

        that.showAddToCollection = false;

        that.collectionBackgroundColors.selected =
          that.collectionBackgroundColors.options[1];
        that.setProcessing(false);
      });

    return this;
  };

  public handleFullscreen = (image: IDavis.IImage): any => {

    // Capture the control that opened the dialog (e.g. the Fullscreen button on
    // the thumbnail) at click time, while it still has focus, so we can return
    // focus to it when the dialog closes (WCAG 2.4.3 Focus Order).
    this.fullscreenTriggerElement = document.activeElement as HTMLElement;

    this.image = image;
    var args: any = {
      image: this.image,
    };
    this.apiService
      .request("davisdigital:api.saveFullScreenData", args)
      .then((data) => {
        console.log("Done");
      });
    return this.initFullscreenModal();
  };

  // Return keyboard focus to the control that opened the full-screen dialog.
  private restoreFullscreenFocus = (): void => {
    const triggerEl = this.fullscreenTriggerElement;
    this.fullscreenTriggerElement = null;
    if (triggerEl && typeof triggerEl.focus === "function") {
      // Defer so focus lands after the modal has been removed from the DOM.
      this.$timeout(() => {
        triggerEl.focus();
      });
    }
  };

  /* https://github.com/dwmkerr/angular-modal-service#showmodal-options*/
  public initFullscreenModal = (opener?: HTMLElement): ng.IPromise<any> => {
    // Capture the control that opened the viewer before ModalService blurs it (WCAG 2.4.3)
    const trigger = opener || (document.activeElement as HTMLElement);
    let restoreScheduled = false;

    const focusTrigger = () => {
      // Don't fight the user if they've already moved focus somewhere real
      const active = document.activeElement as HTMLElement;
      if (active && active !== document.body && active !== trigger && document.body.contains(active)
        && !active.closest("modal-image-fullscreen, #GalleryModalCenter")) {
        return;
      }
      returnFocus(trigger);
    };

    const restoreFocus = () => {
      if (restoreScheduled) return;
      restoreScheduled = true;
      // Wait for the modal markup to be hidden/removed so focus isn't placed inside it
      this.$timeout(focusTrigger, 0, false);
      // Re-check once the close transition and DOM removal have finished; Bootstrap's
      // hide and angular-modal-service's cleanup can otherwise drop focus back to <body>
      this.$timeout(focusTrigger, 350, false);
    };

    return this.ModalService.showModal({
      component: "modalImageFullscreen",
      bodyClass: "angular-modal-service-active",
      bindings: {
        image: this.image,
      },
      // This method is invoked when `ModalService.closeModals()` is called from within ModalService
      preClose: (modal: IDavis.Modal, result: any) => {
        // We need this in order to properly close the Bootstrap modal via `.modal('hide')`
        modal.element.modal("hide");
      },
    })
      .then((modal: any): void => {
        // required for Bootstrap Modal
        modal.element.modal("show");

        // When the dialog closes (Close button or Esc both call
        // ModalService.closeModals(), which resolves this promise), return
        // focus to the element that opened it.
        if (modal.close && typeof modal.close.then === "function") {
          modal.close.then(() => {
            this.restoreFullscreenFocus();
          });
        } else {
          // Fallback for environments without a close promise.
          this.restoreFullscreenFocus();
        }
      })
      .catch((error: any) => {
        console.error(
          "imageController.initModal().ModalService.showModal().ERROR",
          error
        );
        // Ensure focus is not stranded if the dialog failed to open.
        this.restoreFullscreenFocus();
      });
  };

  // Ellipses Menu
  public handleEditImageSet = (imageSet = this.imageSet): this => {
    // Capture the opener before ModalService blurs it. On close, focus moves to the next
    // focusable element after it (skipping its ellipsis menu) (WCAG 2.4.3).
    const trigger = document.activeElement as HTMLElement;
    // Computed now too, in case the card is re-rendered (ng-repeat) while the dialog is open
    const nextAtOpen = getNextFocusable(trigger);

    this.ModalService.showModal({
      component: "imageCollectionEditModal",
      bodyClass: "angular-modal-service-active",
      bindings: {
        imageSet: imageSet,
        collectionBackgroundColors: this.collectionBackgroundColors,
      },
      preClose: (modal) => {
        modal.element.modal("hide");
      },
    }).then((modal) => {
      //it's a bootstrap element, use 'modal' to show it
      modal.element.modal("show");
      modal.close.then((result) => { });

      let restored = false;
      const restore = () => {
        if (restored) return;
        restored = true;
        // Wait until the modal markup is hidden/removed so it isn't picked as the next element
        this.$timeout(() => {
          const next = getNextFocusable(trigger) || nextAtOpen;
          if (next && document.body.contains(next)) {
            next.focus();
            if (document.activeElement === next) return;
          }
          returnFocus(trigger, this.ModalService);
        }, 0, false);
      };
      // `closed` resolves after the modal element is removed (Close button, X, Esc, Save)
      if (modal.closed && typeof modal.closed.then === "function") {
        modal.closed.then(restore);
      }
      // Bootstrap can also dismiss it itself (backdrop click)
      modal.element.one("hidden.bs.modal", restore);
    });

    return this;
  };

  public handleConfirmDeleteImageSet = (imageSet: IDavis.IImageSet): this => {
    this.ModalService.showModal({
      component: "confirmDeleteModal",
      bodyClass: "angular-modal-service-active",
      bindings: {
        title: "This collection will be deleted",
        deleteAction: "delete",
        type: "collection",
        closeCallback: (confirmDelete = false) => {
          return confirmDelete ? this.deleteImageSet(imageSet) : false;
        },
      },
      preClose: (modal) => {
        modal.element.modal("hide");
      },
    }).then((modal) => {
      //it's a bootstrap element, use 'modal' to show it
      modal.element.modal("show");
      modal.close.then((result) => { });
    });

    return this;
  };

  public handleModalSaveAction = (): this => {
    if (this.hasOwnProperty(this.modalSaveAction)) {
      this[this.modalSaveAction]();
    }

    return this;
  };

  public deleteImageSet = (imageSet: IDavis.IImageSet): this => {
    const that = this;

    // Check permissions?

    this.setProcessing(true)
      .imageService.deleteImageSet(imageSet.imageSetID)
      .then((value: IDavis.IImageSet): void => {
        let deletedImageSet = value;
        // Possibly toast confirmation of delete here?
      })
      .then((): void => {
        that.go();
      })
      .catch((reason: any): void => {
        that.handleError(reason);
      })
      .finally((): void => {
        that.setProcessing(false);
      });

    return this;
  };

  public handleShareImageSet = (imageSet: any = this.imageSet) => {
    this.listingModalService.launchImageCollectionShareModal(
      imageSet,
      this.superUser,
      this.go
    );
  };

  public handleCopyImageSet = (imageSet: any = this.imageSet) => {
    this.listingModalService.launchImageCollectionCopyModal(imageSet);
  };

  // @END Ellipses Menu

  public toggleFiltersExpanded = () => {
    this.filtersExpanded = !this.filtersExpanded;
    if (!this.filterOptionsLoaded) {
      this.loadFilterOptions();
    }

    // When the filter panel is collapsed, return keyboard focus to the Filter
    // button so keyboard and screen reader users keep their place on the page.
    // (WCAG 2.4.3 Focus Order). The collapse can be triggered either from the
    // Filter button itself or from the "Hide Additional Filters" link inside
    // the panel, which is removed from the DOM on collapse, so we restore focus
    // explicitly in both cases.
    if (!this.filtersExpanded) {
      this.$timeout(() => {
        const filterButton = this.$element[0].querySelector(
          "#image-filter-toggle"
        ) as HTMLElement;
        if (filterButton) {
          filterButton.focus();
        }
      });
    }

    return this;
  };

  //method to load filter options
  private loadFilterOptions = () => {
    this.filtersLoading = true;
    return this.getFilterOptions().finally(() => {
      this.filtersLoading = false;
    });
  };

  public applyDefaultFilter = (imageFilter, imageFilterValue) => {
    let findInOptions = [];
    switch (imageFilter) {
      case "artistName":
      case "imageName":
        this.keywordConfig[imageFilter] = imageFilterValue;
        break;
      case "nation.nationID":
      case "periods.periodID":

        findInOptions = this.optionsConfig[imageFilter].filter((col) => {
          return col["name"] == imageFilterValue;
        });

        break;
      case "artisticStyle":
      case "originalWorkSubject":
      case "artisticForm":
      case "originalWorkCity":

        findInOptions = this.optionsConfig[imageFilter].filter((col) => {
          return col["value"] == imageFilterValue;
        });

        break;
    }
    if (findInOptions.length > 0) {
      this.filterConfig[imageFilter] = findInOptions[0];
    } else {
      // If no options are defined for this filter, fall back to direct value filtering
      // Expecting backend to accept filterConfig[imageFilter].value
      if (!this.optionsConfig[imageFilter]) {
        this.filterConfig[imageFilter] = { value: imageFilterValue } as any;
      }
    }
  };

  public resetKeywordConfig = () => {
    this.keywordConfig = {
      imageName: "",
      artistName: "",
      daiCatalogNumber: "",
    };

    //for chaining
    return this;
  };

  public resetFilterConfig = () => {
    this.filterConfig = {
      artisticForm: null,
      artisticStyle: null,
      "nation.nationID": null,
      "originalWorkCity": null,
      originalWorkMaterial: null,
      "museum.museumID": null,
      "periods.periodID": null,
      originalWorkSubject: null,
      bookImageOptions: null,
      chapterImageOptions: null,
      bookLessonImageOptions: null,
    };

    //for chaining
    return this;
  };

  public preloadImages = (imageArray) => {
    imageArray.forEach((image) => {
      const img = new Image();
      img.src = image.image_s3PathToImageFile; // Preload each image
    });
  }

  public handleLaunchSlideshow = () => {
    // Step 1: Fetch the images first
    this.imageService.getImageSetImages(
      this.imageSetID,
      this.currentPage,
      this.pageSize['selected'].value,
      this.keywords,
      this.k5appropriate,
      this.sortBy['selected'].value,
      true
    ).then((value: any) => {
      this.preloadImages(value.pages);
      // Step 2: Once images are fetched, open the modal and initialize with images
      this.ModalService.showModal({
        component: "imageGallerySlideshowModal",
        bodyClass: "angular-modal-service-active",
        scope: this.$scope,
        bindings: {
          images: value.pages,  // Initialize the modal with fetched images
          type: "images",
        },
        preClose: (modal) => {
          modal.element.modal("hide");
          this.ModalService.closeModals();
        }
      }).then((modal) => {
        modal.close.then((result) => {

        });
      });
    });
  };

  /**
   * Checkbox Handlers
   */
  public handleSelectedImageCheckbox = (imageID: string): this => {
    let index: number = this.imageSelection.indexOf(imageID);
    let type = this.selectedtab === "imagesearch" ? "images" : "imageSetImages";

    if (index >= 0) {
      this.imageSelection.splice(index, 1);
      delete this.selectedCompareImages[imageID];
      return this;
    } else {
      this.imageSelection.push(imageID);
    }

    if (this[type] == null || this[type].pages == null) {
      return this;
    }

    //try to set image for compare and contrast logic when there's two images

    for (let i = 0; i < this[type].pages.length; i++) {
      const pageImage = this[type].pages[i];
      if (
        (pageImage.imageSetImageID != null &&
          (pageImage.imageSetImageID === imageID ||
            pageImage.image_imageID === imageID)) ||
        pageImage.imageID === imageID
      ) {
        this.selectedCompareImages[imageID] =
          this.buildImageCompareObject(pageImage);
        break;
      }
    }

    return this;
  };

  private buildImageCompareObject(image): any {
    return {
      s3PathToImageFile: !image.imageSetImageID
        ? image.s3PathToImageFile
        : image.image_s3PathToImageFile,
      artistName: !image.imageSetImageID
        ? image.artistName
        : image.image_artistName,
      imageName: !image.imageSetImageID
        ? image.imageName
        : image.image_imageName,
    };
  }

  public handleSelectAllImages = (): this => {
    let selectedImages = this.imageSelection;
    let images: any = this.images.hasOwnProperty("pages")
      ? this.images.pages
      : this.imageSetImages.hasOwnProperty("pages")
        ? this.imageSetImages.pages
        : [];

    images.forEach((image: any): void => {
      if (
        image.imageID != null &&
        selectedImages.indexOf(image.imageID) === -1
      ) {
        selectedImages.push(image.imageID);
        this.selectedCompareImages[image.imageID] =
          this.buildImageCompareObject(image);
      }

      if (
        image.image_imageID != null &&
        selectedImages.indexOf(image.image_imageID) === -1
      ) {
        selectedImages.push(image.image_imageID);
        this.selectedCompareImages[image.image_imageID] =
          this.buildImageCompareObject(image);
      }
    });

    this.setImageSelection(selectedImages);

    return this;
  };

  public handleDeselectAllImages = (): this => {
    this.setImageSelection([]);
    this.selectedCompareImages = {};

    return this;
  };
  // @END :: Checkbox Handlers

  public handleTabClick = (clickEvent: any = {}): this => {
    this.setProcessing(true);
    let oldtab: IDavis.ImageTab = this.selectedtab;

    let newtab: IDavis.ImageTab = clickEvent.hasOwnProperty("currentTarget")
      ? clickEvent.currentTarget.name
      : angular.element("#" + this.selectedtab + "-tab").attr("name");

    // update state only if it's really intended to change
    this.setTotalPages(1)
      .setCurrentPage(1)
      .setImageId("")
      .setImageSetID("")
      .setImageSelection([])
      .setSelectedTab(newtab)
      .resetFilterConfig()
      .resetKeywordConfig();

    this.setProcessing(false);

    // Move keyboard focus into the newly selected tab panel so keyboard and
    // screen reader users land at the beginning of the associated content
    // instead of having to tab back through the tab list (WCAG 2.4.3 Focus
    // Order). The panel ids match the tab names (e.g. "bookcollections").
    this.focusTabPanel(newtab);

    return this;
  };

  // Programmatically move focus to the tab panel associated with the selected
  // tab. The panels are given tabindex="-1" so they can receive focus without
  // becoming part of the normal tab sequence.
  public focusTabPanel = (tabName: IDavis.ImageTab): void => {
    if (!tabName) {
      return;
    }
    this.$timeout(() => {
      const panel = this.$element[0].querySelector(
        "#" + tabName
      ) as HTMLElement;
      if (panel) {
        panel.focus();
      }
    });
  };

  // @TODO: migrate to log vs. console
  public handleError = (error: any): this => {
    if (this.isDev) {
      console.warn(error);
    }

    this.setProcessing(false);

    return this;
  };
  // @END :: Handlers

  // ------------------------------	Getters		------------------------------

  // Display Methods

  public getShowImageDetail = (): boolean => {
    return !this.processing && this.imageID.length ? true : false;
  };

  public getShowImageSetDetail = (): boolean => {
    return !this.processing && !this.imageID.length && this.imageSetID.length
      ? true
      : false;
  };

  public getShowNoImagesMessage = (): boolean => {
    let response =
      !this.processing &&
        !this.imageID.length &&
        this.imageSetID.length &&
        this.imageSetImages.hasOwnProperty("pages") &&
        this.imageSetImages.pages.length === 0
        ? true
        : false;

    return response;
  };

  public getShowImageListing = (): boolean => {
    return !this.processing &&
      !this.imageID.length &&
      this.images.hasOwnProperty("pages") &&
      this.images.pages.length
      ? true
      : false;
  };

  public getShowImageSetListing = (): boolean => {
    return !this.processing &&
      !this.imageID.length &&
      this.imageSets.hasOwnProperty("pages")
      ? true
      : false;
  };

  public getShowAddToCollection = (): boolean => {
    return this.getShowImageListing() && this.selectedtab !== "mycollections"
      ? true
      : false;
  };

  // Document-level listeners active only while the Add to Collection dialog is open
  private addToCollectionKeydownListener: ((e: KeyboardEvent) => void) | null = null;
  private addToCollectionFocusinListener: ((e: FocusEvent) => void) | null = null;

  private getAddToCollectionDialog = (): HTMLElement | null =>
    this.$element[0].querySelector('#image-add-to-collection-wrapper');

  /**
   * Focusable controls in the dialog that are actually reachable right now. Excludes
   * the inactive tab pane, ng-show/ng-hide'd items and disabled buttons; otherwise
   * the "last" element is hidden and the Tab wrap check never matches.
   */
  private getAddToCollectionFocusables = (dialog: HTMLElement): HTMLElement[] => {
    const nodes = dialog.querySelectorAll(this.focusableSelector);
    return Array.prototype.filter.call(nodes, (el: HTMLElement) =>
      !(el as HTMLButtonElement).disabled &&
      el.getAttribute('aria-hidden') !== 'true' &&
      el.getClientRects().length > 0
    );
  };

  /** Open the Add to Collection dialog and keep keyboard focus inside it (WCAG 2.1.2). */
  public trapFocus = (event?: any) => {
    // Store the element that triggered the dialog for focus restoration
    this.previouslyFocusedElement =
      (event && event.currentTarget) || (document.activeElement as HTMLElement);

    // Open the dialog
    this.showAddToCollection = true;
    this.enableAddToCollectionTrap();

    // Set focus to the close button after the dialog is visible
    this.$timeout(() => {
      const dialog = this.getAddToCollectionDialog();
      const closeBtn = dialog && (dialog.querySelector('.navbar-close') as HTMLElement);
      if (closeBtn) {
        closeBtn.focus();
      }
    }, 300);
  }

  private addToCollectionDestroyHooked = false;

  private enableAddToCollectionTrap = () => {
    this.disableAddToCollectionTrap();

    // Never leave document listeners behind if the controller is torn down while open
    if (!this.addToCollectionDestroyHooked) {
      this.addToCollectionDestroyHooked = true;
      this.$scope.$on('$destroy', this.disableAddToCollectionTrap);
    }

    // Capture phase so the trap runs no matter which element inside the page has focus
    this.addToCollectionKeydownListener = (e: KeyboardEvent) => this.handleDialogKeydown(e);

    // Pull focus back if it lands outside the dialog by any other route
    // (programmatic focus, screen reader navigation, etc.)
    this.addToCollectionFocusinListener = (e: FocusEvent) => {
      const dialog = this.getAddToCollectionDialog();
      if (!this.showAddToCollection || !dialog) return;
      const target = e.target as Node;
      // Leave other dialogs (e.g. a modal opened from this one) alone
      const targetEl = target as HTMLElement;
      if (dialog.contains(target) || (targetEl.closest && targetEl.closest('.modal'))) return;
      const focusables = this.getAddToCollectionFocusables(dialog);
      if (focusables.length) focusables[0].focus();
    };

    document.addEventListener('keydown', this.addToCollectionKeydownListener, true);
    document.addEventListener('focusin', this.addToCollectionFocusinListener, true);
  };

  private disableAddToCollectionTrap = () => {
    if (this.addToCollectionKeydownListener) {
      document.removeEventListener('keydown', this.addToCollectionKeydownListener, true);
      this.addToCollectionKeydownListener = null;
    }
    if (this.addToCollectionFocusinListener) {
      document.removeEventListener('focusin', this.addToCollectionFocusinListener, true);
      this.addToCollectionFocusinListener = null;
    }
  };

  /**
   * Switch between "New Collection" and "Add to Existing Collection" and move
   * keyboard focus to the first field of the newly displayed section (WCAG 2.4.3).
   */
  public selectAddToCollectionMode = (addToExisting: boolean) => {
    this.addToExistingImageSet = addToExisting;

    const targetId = addToExisting ? 'inputSearchCollections' : 'inputCollectionTitle';

    // Wait for the digest to apply the pane's active/show classes before focusing
    this.$timeout(() => {
      const input = document.getElementById(targetId) as HTMLInputElement | null;
      if (input) {
        input.focus();
      }
    });
  };

  /**
   * Close the Add to Collection panel and return focus to the button that opened it
   * (WCAG 2.4.3). Used by both the Close (×) button and the Escape key.
   */
  public closeAddToCollection = () => {
    this.showAddToCollection = false;
    this.disableAddToCollectionTrap();

    const trigger = this.previouslyFocusedElement;
    this.previouslyFocusedElement = null;

    // Wait for the panel to collapse so focus doesn't land on a hidden element
    this.$timeout(() => {
      returnFocus(trigger || (document.querySelector('.image-add-collection') as HTMLElement));
    });
  };

  public handleDialogKeydown = (event: KeyboardEvent) => {
    const dialog = this.getAddToCollectionDialog();
    if (!this.showAddToCollection || !dialog) {
      // Dialog was closed by another path (e.g. a successful save); stop trapping
      this.disableAddToCollectionTrap();
      return;
    }

    // Don't interfere with a modal opened on top of this dialog
    if (document.querySelector('.modal.show')) return;

    if (event.key === 'Escape' || event.keyCode === 27) {
      event.preventDefault();
      this.$scope.$applyAsync(() => this.closeAddToCollection());
      return;
    }

    if (event.key !== 'Tab' && event.keyCode !== 9) return;

    const focusables = this.getAddToCollectionFocusables(dialog);
    if (focusables.length === 0) {
      event.preventDefault();
      return;
    }

    const first = focusables[0];
    const last = focusables[focusables.length - 1];
    const active = document.activeElement as HTMLElement;
    const inside = dialog.contains(active);

    if (event.shiftKey) {
      if (!inside || active === first) {
        event.preventDefault();
        last.focus();
      }
    } else if (!inside || active === last) {
      event.preventDefault();
      first.focus();
    }
  }

  public getDisableAddToCollectionButton = (): boolean => {
    return this.processing ||
      this.imageSetName.length === 0 ||
      this.imageSelection.length === 0
      ? true
      : false;
  };

  public getSelectedTabText = (): string => {
    let tabText = "";

    switch (this.selectedtab) {
      case "mycollections":
        tabText = "My Collections";
        break;
      case "sharedcollections":
        tabText = "Shared Collections";
        break;
      case "bookcollections":
        tabText = "Book Collections";
        break;
      case "daviscollections":
        tabText = "Davis Collections";
        break;
      case "imagesearch":
        tabText = "Image Search";
        break;
      default:
        this.handleError({
          message: "getSelectedTabText() Error!",
          detail: "Unknown tab: " + this.selectedtab,
        });
    }

    return tabText;
  };

  public getBackgroundColor = (): string => {
    let backgroundColor =
      this.getShowImageSetDetail() &&
        this.hasOwnProperty("imageSet") &&
        this.imageSet.hasOwnProperty("backgroundColor")
        ? "{ 'background-color': '#" + this.imageSet.backgroundColor + "' }"
        : "";

    return backgroundColor;
  };

  public getFilterOptions = (): ng.IPromise<any> => {
    return this.imageService
      .getFilterOptions()
      .then((response: any) => {
        this.filterOptionsLoaded = true;
        this.optionsConfig = response;
      })
      .finally(() => {
        for (let key in this.optionsConfig) {
          if (
            Array.isArray(this.optionsConfig[key]) &&
            this.optionsConfig[key].length > 0
          ) {
            this.filterConfig[key] = this.optionsConfig[key][0];
          }
        }
      });
  };
  // @END :: Getters

  // ------------------------------	Setters		------------------------------

  //	***		Entities	***

  // Image Search
  private setImages = (keywords: string = ""): this => {
    let that = this;
    keywords = keywords.length ? keywords : that.keywords;
    let lessonId = "";
    if ("undefined" !== typeof this.selectedLessonId) {
      lessonId = this.selectedLessonId.bookLessonImageOptionID;
    }
    this.setProcessing(true)
      .imageService.getImages(
        that.currentPage,
        that.pageSize["selected"].value,
        keywords,
        that.k5appropriate,
        that.sortBy["selected"].value,
        that.arrayImagesIDs,
        undefined,
        that.filterConfig,
        that.keywordConfig
      )
      .then((value: IDavis.ImageCollectionList): void => {
        that.images = value;
        that.setTotalPages(value.totalPages);
      })
      .catch((reason: any): void => {
        that.handleError(reason);
      })
      .finally((): void => {
        that.setProcessing(false);
        if (that.selectedtab === "imagesearch") {
          that.shepherdService.initShepherdImageListing();
        }
      });

    return this;
  };

  // Image Detail
  private setImage = (imageID: string = ""): this => {
    const that = this;

    imageID = imageID.length ? imageID : that.imageID;

    this.setProcessing(true)
      .imageService.getImageDetails(imageID)
      .then((value: IDavis.IImage): void => {
        that.image = this.handleImageDescription(value);
      })
      .catch((reason: any): void => {
        that.handleError(reason);
      })
      .finally((): void => {
        that.setProcessing(false);
        that.shepherdService.initShepherdImageDetail();
      });

    return this;
  };

  // Image Set Detail / Collection Detail
  private setImageSet = (imageSetID: string = ""): this => {
    const that = this;

    imageSetID = imageSetID.length ? imageSetID : that.imageSetID;

    this.setProcessing(true)
      .imageService.getImageSet(imageSetID)
      .then((value: IDavis.IImageSet): void => {
        that.imageSet = value;
      })
      .then((): void => {
        that.setImageSetImages();
      })
      .catch((reason: any): void => {
        that.handleError(reason);
      })
      .finally((): void => {
        that.setProcessing(false);
      });

    return this;
  };

  // Collections
  private setImageSets = (): this => {
    let that = this;

    var orderByProperty = this.sortBy.selected.value;

    if (orderByProperty === "artistName") {
      orderByProperty = "createdDateTime";
    }

    this.setProcessing(true)
      .imageService.getImageSets(
        that.currentPage,
        that.pageSize["selected"].value,
        that.keywords,
        that.k5appropriate,
        [],
        orderByProperty,
        false,
        that.selectedtab,
        that.sharedWithTeacher,
        that.sharedWithStudent
      )
      .then((value: IDavis.ImageSetCollectionList): void => {
        that.imageSets = value;
        that.setTotalPages(value.totalPages);
      })
      .catch((reason: any): void => {
        that.handleError(reason);
      })
      .finally((): void => {
        that.setProcessing(false);
      });

    return this;
  };

  // Image Set Images (used by all Image Sets)
  private setImageSetImages = (): this => {
    let that = this;

    this.setProcessing(true)
      .imageService.getImageSetImages(
        that.imageSetID,
        that.currentPage,
        that.pageSize["selected"].value,
        that.keywords,
        that.k5appropriate,
        that.sortBy["selected"].value
      )
      .then((value: any): void => {
        that.imageSetImages = value;
        that.setTotalPages(value.totalPages);
      })
      .catch((reason: any): void => {
        that.handleError(reason);
      })
      .finally((): void => {
        that.setProcessing(false);
      });

    return this;
  };

  // @END :: Entities

  //	***		Location Settings	***

  private setLocation = (
    param: string,
    paramVal?: string | number | boolean
  ): this => {
    // if the value is a string and it's empty, remove it
    if (typeof paramVal === "string" && !paramVal.length) {
      paramVal = null;
    }

    this.$location.search(param, paramVal || null);
    return this;
  };

  private setSelectedTab = (
    newTab?: IDavis.ImageTab,
    backlinkText = ""
  ): this => {
    let tab =
      newTab && newTab.length
        ? newTab
        : this.$location.search().tab || "imagesearch";

    this.selectedtab = tab;
    this.setLocation("tab", this.selectedtab)
      .setBacklinkText(this.getSelectedTabText())
      .setTabClasses();

    //clear existing list
    this.sortBy = {};
    this.pageSize = {};
    this.keywords = "";

    // //set sorting & page options based on tab
    if (this.imageSetID != null && this.imageSetID.trim().length > 0) {
      this.sortBy = this.imageSortBy;
      this.pageSize = this.imagePageSize;
    } else if (this.selectedtab == "mycollections") {
      this.sortBy = this.myCollectionsSortBy;
      this.pageSize = this.imagePageSize;
    } else if (this.selectedtab == "daviscollections") {
      this.sortBy = this.davisCollectionsSortBy;
      this.pageSize = this.sharedCollectionsPageSize;
    } else if (this.selectedtab == "bookcollections") {
      this.sortBy = this.bookCollectionsSortBy;
      this.pageSize = this.sharedCollectionsPageSize;
    } else if (this.selectedtab == "sharedcollections") {
      this.sortBy = this.sharedCollectionsSortBy;
      this.pageSize = this.sharedCollectionsPageSize;
    } else if (this.selectedtab == "imagesearch") {
      this.sortBy = this.imageSortBy;
      this.pageSize = this.imagePageSize;

      //no back functionality from search to image
      this.setReferrerImageID();
    }

    if (this.selectedtab.length) {
      this.setLocation("keywords", "");
      this.setLocation("referrerImageID", "");
    }

    //apply first option as default
    this.sortBy["selected"] = this.sortBy.options[0];
    this.pageSize["selected"] = this.pageSize.options[0];

    return this;
  };

  private setImageId = (imageID: string = ""): this => {
    this.imageID = imageID;
    this.setLocation("imageid", imageID ? imageID : null);
    return this;
  };

  private setImageSetID = (imageSetID: string = ""): this => {
    this.imageSetID = imageSetID;
    this.setLocation("imagesetid", imageSetID.length ? imageSetID : null);
    return this;
  };

  private setCurrentPage = (currentPage: number = 1, forceSet: boolean = false): this => {
    if (forceSet) {
      this.currentPage = currentPage;
    } else {
      this.currentPage =
        +this.totalPages === 1 || +currentPage <= +this.totalPages
          ? +currentPage
          : 1;
    }


    this.setLocation("currentPage", this.currentPage);
    return this;
  };

  private setReferrerPage = (referrerPage: number = 1): this => {
    this.referrerPage = referrerPage;
    return this;
  };

  private setReferrerImagePage = (referrerImagePage: number = 1): this => {
    this.referrerImagePage = referrerImagePage;
    return this;
  };

  // ***	These have no impact on $location (yet)		***
  private setKeywords = (keywords: string = ""): this => {
    this.keywords = keywords;
    if (this.keywords.length) {
      this.setLocation("keywords", this.keywords);
    }
    return this;
  };

  private setK5Appropriate = (k5appropriate: boolean = true): this => {
    this.k5appropriate = k5appropriate;
    return this;
  };

  private setSortOrder = (sortOrder: number | string = 1): this => {
    this.sortOrder = sortOrder;
    return this;
  };

  private setTotalPages = (totalPages: number = 1): this => {
    this.totalPages = +totalPages;
    return this;
  };

  // @END :: Location Settings
  private setImageSelection = (imageSelection: string[] = []): this => {
    this.imageSelection = imageSelection;
    return this;
  };

  private setReferrerImageID = (referrerImageID?: string): this => {
    if (referrerImageID == null || referrerImageID.trim().length === 0) {
      this.referrerImageID = null;
      this.$location.search("referrerImageID", this.referrerImageID);
      return this;
    }

    // this.setBacklinkText("Image");

    this.referrerImageID = referrerImageID;
    this.$location.search("referrerImageID", this.referrerImageID);

    return this;
  };

  private setReferrerImageSetID = (
    referrerImageSetID?: string,
    imageSetTitle = "Image Collection"
  ): this => {
    if (referrerImageSetID == null || referrerImageSetID?.trim().length === 0) {
      this.referrerImageSetID = null;
      this.$location.search("referrerImageSetID", null);
      return this;
    }

    if (imageSetTitle === "Image Collection" && this.imageSet != null) {
      imageSetTitle = this.imageSet.title;
    }

    this.setBacklinkText(imageSetTitle);

    this.referrerImageSetID = referrerImageSetID;

    this.$location.search("referrerImageSetID", this.referrerImageSetID);

    return this;
  };

  private setTabClasses = (): this => {
    this.tabClasses = {
      imagesearch: "",
      mycollections: "",
      sharedcollections: "",
      daviscolletions: "",
    };

    this.tabClasses[this.selectedtab] = "show active";
    return this;
  };

  private setBacklinkText = (backlinktext: string = ""): this => {
    if (backlinktext.trim().length === 0 && this.backlinktext == null) {
      this.backlinktext = this.getSelectedTabText();
    } else if (backlinktext.trim().length !== 0) {
      this.backlinktext = backlinktext;
    }

    return this;
  };

  private setProcessing = (processing: boolean = true): this => {
    if (processing) {
      this.rememberFocusBeforeProcessing();
    }

    this.processing = processing;
    this.$window.scrollTo(0, 0);
    if (!this.processing) {
      this.permissions = this.apiService.getPermissions();
      this.restoreFocusAfterProcessing();
    }
    return this;
  };

  /**
   * While `processing` is true, images.cfm removes the tab content (`ng-if="!imageCtrl.processing"`),
   * destroying whatever control the user just operated (e.g. the K-5 / Shared With filter checkboxes)
   * and dropping focus to <body>. Remember that control by id so focus can be put back on its
   * re-rendered replacement once loading finishes (WCAG 2.4.3).
   */
  private focusIdBeforeProcessing: string | null = null;

  private rememberFocusBeforeProcessing = (): void => {
    const active = document.activeElement as HTMLElement;
    const container: HTMLElement = this.$element && this.$element[0];

    if (active && active !== document.body && active.id && container && container.contains(active)) {
      this.focusIdBeforeProcessing = active.id;
    }
    // Otherwise keep any id already stored: with nested loads, focus may already have been lost
  };

  private restoreFocusAfterProcessing = (): void => {
    if (!this.focusIdBeforeProcessing) return;

    // Wait for the digest so the ng-if content (and the new control) is back in the DOM
    this.$timeout(() => {
      const id = this.focusIdBeforeProcessing;
      if (!id || this.processing) return; // another load started; try again when it ends

      const active = document.activeElement as HTMLElement;
      // Only step in when focus was actually lost; never steal it from somewhere the user moved to
      if (active && active !== document.body) {
        this.focusIdBeforeProcessing = null;
        return;
      }

      const target = document.getElementById(id) as HTMLInputElement | null;
      // Clear either way so a stale id can't pull focus during some later, unrelated load
      this.focusIdBeforeProcessing = null;
      if (target && !target.disabled && target.offsetParent !== null) {
        target.focus();
      }
    }, 0, false);
  };

  public arrayDelete = (arr: any[], val: any): any => {
    return arr.filter((el: any) => {
      return el != val;
    });
  };

  public handleBookImageOptions = () => {
    this.imageOptionsLoading = true;

    if (this.filterConfig["chapterImageOptions"]?.value.length === 32) {
      this.filterConfig["chapterImageOptions"] =
        this.optionsConfig["chapterImageOptions"][0];
    }

    if (this.filterConfig["bookLessonImageOptions"]?.value.length === 32) {
      this.filterConfig["bookLessonImageOptions"] =
        this.optionsConfig["bookLessonImageOptions"][0];
    }

    var args: any = {
      bookImageOptionID: this.filterConfig["bookImageOptions"].value,
    };

    this.chapterImageOptionsLoading = true;

    this.apiService
      .request("davisdigital:api.getChapterAndBookLessonImageOptions", args)
      .then((data) => {
        this.optionsConfig["chapterImageOptions"] =
          data.data.data["chapterImageOptions"];
        this.optionsConfig["bookLessonImageOptions"] =
          data.data.data["bookLessonImageOptions"];

        if (this.filterConfig["chapterImageOptions"]?.value.length === 0) {
          this.filterConfig["chapterImageOptions"] =
            this.optionsConfig["chapterImageOptions"][0];
        }

        if (this.filterConfig["bookLessonImageOptions"]?.value.length === 0) {
          this.filterConfig["bookLessonImageOptions"] =
            this.optionsConfig["bookLessonImageOptions"][0];
        }

        this.chapterImageOptionsLoading = false;
      });
  };

  public handleChapterImageOptions = () => {
    this.imageOptionsLoading = true;

    if (this.filterConfig["bookLessonImageOptions"]?.value.length === 32) {
      this.filterConfig["bookLessonImageOptions"] =
        this.optionsConfig["bookLessonImageOptions"][0];
    }

    var args: any = {
      bookImageOptionID: this.filterConfig["bookImageOptions"].value,
    };

    if (this.filterConfig["chapterImageOptions"]?.value.length) {
      this.bookLessonImageOptionsLoading = true;
      args["chapterImageOptionID"] =
        this.filterConfig["chapterImageOptions"].value;
    } else {
      this.chapterImageOptionsLoading = true;
    }

    this.apiService
      .request("davisdigital:api.getChapterAndBookLessonImageOptions", args)
      .then((data) => {
        this.optionsConfig["bookLessonImageOptions"] =
          data.data.data["bookLessonImageOptions"];

        if (this.filterConfig["bookLessonImageOptions"]?.value.length === 0) {
          this.filterConfig["bookLessonImageOptions"] =
            this.optionsConfig["bookLessonImageOptions"][0];
        }
        this.bookLessonImageOptionsLoading = false;
        this.chapterImageOptionsLoading = false;
      });
  };

  public handleBookLessonImageOptions = () => {
    var args: any = {
      bookImageOptionID: this.filterConfig["bookImageOptions"].value,
    };

    if (this.filterConfig["bookLessonImageOptions"]?.value.length) {
      args["bookLessonImageOptionID"] =
        this.filterConfig["bookLessonImageOptions"].value;
    }
  };

  public getBookLessonOptions = () => {
    var args: any = {
      bookImageOptionID: this.selectedItem.bookImageOptionID,
    };
    this.apiService
      .request("davisdigital:api.getBookLessonImageOptions", args)
      .then(({ data }) => {
        this.optionsConfig["bookLessonImageOptions"] = data.data;
      });
  };
  // @END :: Setters
}
